export const en = {
  dashboardPage: {
    meta: { title: 'Reporting Dashboard' },
    hero: {
      eyebrow: 'Reporting Dashboard',
      heading_main: 'Executive-ready reports,',
      heading_em: 'in seconds',
      lead: 'Hours volunteered and impact — surfaced the moment a shift ends. No analyst and no PowerPoint marathon.',
    },
    availStrip: 'Live data from every shift in real time.',
    ask: {
      name: 'Ask the Dashboard',
      status: 'Early Access',
      headline: 'Plain-English questions, executive-ready answers',
      desc: 'Skip the spreadsheet rabbit hole. Type the question your CFO or CSR lead just asked — the AI pulls the numbers, narrates the trend, and cites every source it used.',
      features: [
        'Natural-language queries across hours, dollars, causes, and teams',
        'Every figure is clickable — drills back to the raw shift data',
        'One-click "draft an exec memo" or "format for the board deck"',
        'Saved questions become recurring reports in your inbox',
      ],
      cta: 'See it on your data →',
      visual: {
        channel: 'Ask Purposely',
        tabLabel: 'AI',
        meta: 'just now',
        question: 'How did Q1 hours compare to last year, and which team drove the lift?',
        answer: 'In <strong>Q1 2026</strong> your team logged <strong>2,847 hours</strong> across 196 volunteers — up <strong>+34%</strong> vs Q1 2025 (2,127h). The lift was driven mostly by <strong>Engineering</strong>, which jumped from 312h → 614h (+97%) after the Stanley Park cleanup series.',
        sourcesLabel: 'Sources:',
        btn1: 'Draft exec memo',
        btn2: 'Format for board deck',
        btn3: 'Save as recurring',
      },
    },
    kpi: {
      name: 'Live KPIs & Trends',
      status: 'Live | Updated in real time',
      headline: 'The numbers your CSR lead checks every Monday',
      desc: 'A single dashboard for hours logged, volunteers active, event hours, return rate, sliced by team, location, cause, or nonprofit. Trend lines update the moment a shift wraps.',
      features: [
        'Filter by team, region, cause, or department with one click',
        'Year-over-year and quarter-over-quarter comparisons built in',
        'Track participation rate, return rate, and first-time volunteers',
      ],
      cta: 'Tour the metrics →',
      visual: {
        channel: 'Overview · Q1 2026',
        meta: 'All teams · YTD',
        chartTitle: 'Hours by month',
        labelHours: 'Hours',
        labelVolunteers: 'Volunteers',
        labelReturnRate: 'Return rate',
        labelDollarEquivalent: '$ equivalent',
        leg2026: '2026',
        leg2025: '2025',
      },
    },
    cause: {
      name: 'Cause & SDG Breakdown',
      status: 'Live',
      headline: 'See where impact landed',
      desc: 'Drill into the causes your team gravitated toward and pull the data you can use to make the right decisions',
      features: [
        'Spot under-represented causes before your impact review',
        'Compare cause mix across offices, BUs, or fiscal years',
      ],
      cta: 'Map your causes →',
      visual: {
        channel: 'Causes · Q1 2026',
        meta: '2,847 hours',
        chartTitle: 'Hours by cause',
        donutLabel: 'Hours',
        c1: 'Food security',
        c2: 'Environment',
        c3: 'Education & youth',
        c4: 'Housing & shelter',
        sdg2: 'Zero hunger',
        sdg4: 'Education',
        sdg11: 'Communities',
        sdg13: 'Climate action',
      },
    },
    teams: {
      name: 'Teams & Exports',
      status: 'Live',
      headline: 'Friendly competition, audit-ready exports',
      desc: "Keep teams engaged through the quarter. When it's time to report, export everything in one click — formats your finance and comms teams already use.",
      features: [
        'Team-level leaderboards by hours or participation rate',
        'One-click exports in CSV for use in Sheets and Excel',
        'Get access to the latest activity at your company, in real time',
      ],
      cta: 'Export a sample report →',
      visual: {
        channel: 'Team leaderboard',
        meta: 'By hours · Q1 2026',
        exp1: 'PDF board snapshot',
        exp2: 'CSV',
        exp3: 'GRI 413',
        exp4: 'Workiva',
        exp5: 'API',
      },
    },
    faq: {
      heading: 'Reporting, Exports & Data',
      items: [
        {
          q: 'Which export formats do you support?',
          a: 'CSV for now. GRI 413, B Corp, and Workiva formats are on the roadmap.',
        },
        {
          q: 'Who can see what in the dashboard?',
          a: 'Dashboard access is admin-only. Team leads and employees see their own activity through their standard Purposely views — the full reporting suite stays in the hands of your CSR or HR admin.',
        },
        {
          q: 'How fresh is the data?',
          a: "Real-time. The moment a shift is logged, it's reflected in your dashboard. No batch jobs, no waiting for Monday's numbers.",
        },
      ],
    },
    cta: {
      heading_main: 'See your impact,',
      heading_em: 'auto-narrated',
      sub: "Book a 20-minute demo and we'll plug in a live dataset so you can ask the dashboard anything.",
      button: 'Book a demo →',
    },
  },
}
